<form [formGroup]="paymentInputFG">
  <div class="p-input-block01__item">
    <div class="p-input-block01__row p-input-block01__row--has-title">
      <div class="p-input-block01__row-head">
        <span class="p-input-block01__row-title" [innerHTML]="travelerName"></span>
      </div>
      <div
        class="p-input-block01__row-body"
        *ngIf="isDisplayPassengerSmsDestination && isPassengerSMSInformationsHasMoreThanTwo === false"
      >
        <div class="p-input-block01__row-body-item">
          <asw-radio-group
            id="{{ id }}-select-phone-type"
            name="radiobutton_phone_{{ id }}"
            direction="vertical"
            [formControlName]="'smsDestination_' + (traveler.id ?? '')"
            (change$)="onChangeSmsDestination()"
          >
            <asw-radio-button
              id="{{ id }}-select-phone-type-item-1"
              value="{{ SMS_DESTINATION.SEND_TO_INDIVIDUAL }}"
              label="{{ 'message.sendToPassengerPhoneNumber' | staticMsg }}"
            ></asw-radio-button>
            <asw-radio-button
              id="{{ id }}-select-phone-type-item-2"
              value="{{ SMS_DESTINATION.DO_NOT_SEND }}"
              label="{{ 'message.notSendSmsToPassenger' | staticMsg }}"
            ></asw-radio-button>
          </asw-radio-group>
        </div>
      </div>
    </div>
    <ng-container *ngIf="isDisplayPassengerSmsInputArea">
      <div class="p-input-block01__row p-input-block01__row--has-title">
        <div class="p-input-block01__row-head">
          <span class="p-input-block01__row-title" [innerHTML]="'label.recipientOfSmsAboutBoarding' | staticMsg"></span>
          <span class="c-label-required" [innerHTML]="'message.mandatory' | staticMsg"></span>
        </div>
        <div class="p-input-block01__row-body" *ngIf="this.passengerSMSInformations.length === 1; else showSmsAsLabel">
          <div class="p-input-block01__row-body-item">
            <div class="p-input-block01__row-body-item-box p-input-block01__row-body-item-box--w294">
              <asw-select
                id="{{ id }}-select-country"
                label="{{ 'label.countryCode' | staticMsg }}"
                [formControlName]="'numberCountry_' + traveler.id"
                (change$)="updateCountryCode()"
              >
                <option
                  *ngFor="let phoneCountryInfo of phoneNumberCountryList"
                  [value]="phoneCountryInfo.country2LetterCode"
                  [innerHTML]="phoneCountryInfo.countryName"
                ></option>
              </asw-select>
            </div>
          </div>
          <div class="p-input-block01__row-body-item">
            <div class="p-input-block01__row-body-item-head">
              <p
                id="describe02"
                class="p-input-block01__row-body-item-text"
                [innerHTML]="'message.phoneNumberAttention' | staticMsg"
              ></p>
            </div>
            <div class="p-input-block01__row-body-item-box p-input-block01__row-body-item-box--w294">
              <asw-input
                id="{{ id }}-input-input-phone-number"
                label="{{ 'label.telephoneNumber' | staticMsg }}"
                placeholder="{{ 'placeholder.phoneNumber.international' | staticMsg }}"
                [phoneCode]="phoneCountryCode"
                displayType="phone"
                maxlength="16"
                [formControlName]="'number_' + traveler.id"
                [conversionType]="'phoneNumber'"
              >
              </asw-input>
            </div>
          </div>
        </div>

        <ng-template #showSmsAsLabel>
          <div class="p-input-block01__row-body">
            <div class="p-input-block01__row-body-item" *ngFor="let phoneLabel of phonesAsLabel">
              <div class="p-input-block01__row-body-item-box p-input-block01__row-body-item-box--w294"></div>
              <div class="p-input-block01__row-body-item">
                <div class="p-input-block01__row-body-item-head">
                  <!-- [8.14] 搭乗者SMSの国番号 -->
                  <p class="p-input-block01__row-body-item-text">{{ phoneLabel.countryName || '' }}</p>
                </div>
                <div class="p-input-block01__row-body-item-box p-input-block01__row-body-item-box--w294">
                  <!-- [8.15] 搭乗者SMS番号 -->
                  <!-- ※電話番号テキストボックス内の先頭に、"+"付きで表示する -->
                  <p class="p-input-block01__row-body-item-text">{{ phoneLabel.phoneNumber || '' }}</p>
                </div>
              </div>
            </div>
          </div>
        </ng-template>
      </div>
    </ng-container>
  </div>
</form>
